import { useCallback, useContext } from 'react';
import { css, styled } from 'styled-components';

import { fadeIn } from '../../../../styles/animation';
import { ConfigurationContext } from '../../../../context/configurationContext';

import * as api from '../../../../api';

interface Props {
  showTextAnimation: boolean;
  address: string;
  staticMap: string;
  messageId: string;
}

const StaticMap: React.FC<Props> = ({
  address,
  staticMap,
  showTextAnimation,
  messageId,
}) => {
  const configurationContext = useContext(ConfigurationContext);

  const createClickedLog = useCallback(async () => {
    if (!configurationContext?.id) return;
    if (!configurationContext.sessionId) return;
    try {
      await api.client.Assistant.createLog({
        action: api.Log.AssistantAuditAction.AssistantPatientClickedStaticMap,
        assistantId: configurationContext.id,
        sessionId: configurationContext.sessionId,
        messageId,
      });
    } catch (error) {
      console.error('Could not add log', error);
    }
  }, [configurationContext?.id, configurationContext?.sessionId, messageId]);

  return (
    <StaticMapContainer
      $showTextAnimation={showTextAnimation}
      data-test-id="static-map"
    >
      <StaticMapLink
        href={address ? `https://maps.google.com/?q=${address}` : undefined}
        target="_blank"
        onClick={() => createClickedLog()}
      >
        <StaticMapImg src={staticMap} alt={'Map location'} />
      </StaticMapLink>
      <MapDescription>{address}</MapDescription>
    </StaticMapContainer>
  );
};

const MapDescription = styled.div`
  font-size: 16px;
`;

const StaticMapContainer = styled.div.attrs<{ $showTextAnimation: boolean }>(
  (props) => ({
    $showTextAnimation: props.$showTextAnimation ?? false,
  }),
)`
  width: 100%;
  border: 1px solid var(--border-color);
  background-color: var(--color-white);
  border-radius: 4px;
  padding: 32px;
  margin-bottom: 1.5rem;
  opacity: ${(props) => (props.$showTextAnimation ? 0 : 1)};
  animation: ${(props) =>
    props.$showTextAnimation
      ? css`
          ${fadeIn} .6s ease-in-out forwards
        `
      : 'none'};
`;

const StaticMapImg = styled.img`
  height: 160px;
  object-fit: none;
  width: 100%;
  margin-bottom: 1.5rem;
`;

const StaticMapLink = styled.a``;

export default StaticMap;
